import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IPhilosophy } from "../philosophyModel";

export const getAllPhilosophies = createAsyncThunk(
  "Philosophy/FindAllPhilosophy",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/FindAllPhilosophy`,
        { Title: "" },
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Philosophies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPhilosophy = createAsyncThunk(
  "Philosophy/InsertPhilosophy",
  async (PhilosophyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/InsertPhilosophy`,
        PhilosophyData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Philosophy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updatePhilosophy = createAsyncThunk(
  "Philosophy/UpdatePhilosophy",
  async (PhilosophyData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/UpdatePhilosophy`,
        PhilosophyData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Philosophy:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deletePhilosophy = createAsyncThunk(
  "Philosophy/DeletePhilosophy",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/DeletePhilosophy`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Philosophy :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPhilosophyByID = createAsyncThunk(
  "Philosophy/FindByIDPhilosophy",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/FindByIDPhilosophy`,
        { ID },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result?.Title,
        URL: result?.URL,
        ShortDescription: result?.ShortDescription || "",
        LongDescription: result?.LongDescription || "",
        SequenceNo: result?.SequenceNo,
        MetaTitle: result?.MetaTitle,
        MetaDescription: result?.MetaDescription,
        MetaKeywords: result?.MetaKeywords,
        BannerImage: result?.BannerImage,
        IsActive: result.IsActive ? 1 : 2,
      } as IPhilosophy;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Philosophy :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getAllActivePhilosophies = createAsyncThunk(
  "Philosophy/FindAllActivePhilosophy",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Philosophy/FindAllActivePhilosophy`,
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Philosophies:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const ActiveInactivePhilosophy = createAsyncThunk(
  "Philosophy/ActiveInActivePhilosophy",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/ActiveInActivePhilosophy`,
        formData,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Philosophy :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

// IMAGE UPLOAD
export const PhilosophyDetailsImageUpload = createAsyncThunk(
  "Philosophy/PhilosophyImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Philosophy/PhilosophyImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Philosophy Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
